import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";
export const ParticipantIntakeSelectionWrapper = styled.div`
  .select-preference-container {
    border-top: 1px dashed ${COLORS.primary_light_blue};
  }
  .select-preference-authorized {
    display: flex;
    align-items: baseline;
  }
  .divider-container {
    border: 3px solid ${COLORS.cirrus_black2};
    margin: 16px;
    border-radius: 4px;
  }

  .career-goal-label-style {
    margin: 34px 16px 0 16px;
    font-size: 20px;
    color: ${COLORS.cirrus_black10};

    ${responsive.MOBILE`
          margin: 16px 16px 0 16px;
        `}
  }
  .sub-label-style {
    font-size: 20px;
    margin-top: 32px;
    color: ${COLORS.cirrus_black7};
  }
`;
